import "./index.css";
import type { IMessageProps } from "./types";
import { clsx } from "clsx";
import { Typography } from "../Typography";

export const Message = ({
  text,
  variant = "primary",
  className,
}: IMessageProps) => {
  const messageClass: string = clsx(
    "nuco-message",
    `nuco-message--${variant}`,
    className,
  );

  return (
    <Typography as="p" className={messageClass} text={text} role="alert" />
  );
};
